import React from 'react';
import { UserAccess } from 'components/user-access';
import { HorizontalLinkGroup } from 'components/navigation';
import { PageRestricted } from 'pages/errors/page-restricted';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Cost, Supplier } from 'pages/fleet/fleet-settings';

export function CostSupplier(props) {
    const requiredAction = "FMS:Manage";

    const routes = [
        { location: "/fleet-settings/cost-supplier/cost", title: "Costs" },
        { location: "/fleet-settings/cost-supplier/supplier", title: "Suppliers" }
    ];

    return (
        <UserAccess perform={requiredAction}
            yes={() => (
                <div className="row">
                    <h2>Costs and Suppliers</h2>

                    <div className="spacer-bottom">
                        <HorizontalLinkGroup links={routes} exactRouteMatch={false}></HorizontalLinkGroup>
                    </div>

                    <Routes>
                        <Route path="cost" element={<Cost />} />
                        <Route path="supplier" element={<Supplier />} />
                        <Route path="" element={<Navigate to="/fleet-settings/cost-supplier/cost" replace />} />
                    </Routes>
                </div>
            )}
            no={() => (
                <div className="row">
                    <PageRestricted />
                </div>
            )}
        />
    );
}